import apiClient from '../apiClient';

/**
 * Delivery Schedule API — fetches and manages supplier-specific delivery time slots.
 */

/**
 * Get all delivery schedules for the current supplier.
 * Auto-seeds defaults if none exist.
 * @returns {Promise<Array<{publicId: string, name: string, startTime: string|null, endTime: string, isDefault: boolean, sortOrder: number}>>}
 */
export const getDeliverySchedules = async () => {
    try {
        const response = await apiClient.get('/delivery-schedules');
        return response.data || [];
    } catch (error) {
        console.error('Error fetching delivery schedules:', error);
        return [];
    }
};

/**
 * Create a new delivery schedule.
 * @param {{name: string, startTime?: string, endTime: string, isDefault: boolean, sortOrder: number}} data
 */
export const createDeliverySchedule = async (data) => {
    try {
        const response = await apiClient.post('/delivery-schedules', data);
        return response.data;
    } catch (error) {
        console.error('Error creating delivery schedule:', error);
        throw error;
    }
};

/**
 * Update an existing delivery schedule.
 * @param {string} publicId
 * @param {{name: string, startTime?: string, endTime: string, isDefault: boolean, sortOrder: number}} data
 */
export const updateDeliverySchedule = async (publicId, data) => {
    try {
        const response = await apiClient.put(`/delivery-schedules/${publicId}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating delivery schedule:', error);
        throw error;
    }
};

/**
 * Delete a delivery schedule.
 * @param {string} publicId
 */
export const deleteDeliverySchedule = async (publicId) => {
    try {
        await apiClient.delete(`/delivery-schedules/${publicId}`);
    } catch (error) {
        console.error('Error deleting delivery schedule:', error);
        throw error;
    }
};

/**
 * Reorder delivery schedules.
 * @param {string[]} publicIds — ordered list of delivery schedule publicIds
 */
export const reorderDeliverySchedules = async (publicIds) => {
    try {
        const response = await apiClient.put('/delivery-schedules/reorder', publicIds);
        return response.data || [];
    } catch (error) {
        console.error('Error reordering delivery schedules:', error);
        throw error;
    }
};
